import { InputTab, Typography } from '@libs/components';
import styled from 'styled-components';
import CurrencyInputWithBalanceOptions from '../currency-input-with-balance-options/CurrencyInputWithBalanceOptions';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem;
  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem 3.6rem 3.6rem;

  `};

  width: 100%;
`;

export const CurrencyInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  width: 100%;
`;

export const AmountTextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
  gap: 0.8rem;
`;

export const AmountTextWrapper = styled.div`
  display: flex;
  align-items: center;

  justify-content: space-between;

  width: 100%;
`;

export const CustomTypography = styled(Typography)`
  margin-bottom: 1rem;
  line-height: 2.5rem;
`;

export const ZeroBalanceDisclaimer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  background-color: ${({ theme }) => theme.colors.surface.rejectedBackground};
  padding: 1rem;
  margin-top: 1.2rem;
`;

export const InputTabWrapper = styled.div`
  margin-top: 1.2rem;
`;

export const CustomCurrencyInputWithBalanceOptions = styled(
  CurrencyInputWithBalanceOptions
)`
  .common-input {
    font-size: 2.4rem;
  }
  ,
  .max-button {
    color: ${({ theme }) => theme.colors.borders.highlight};
  }
  .input-container {
    min-height: 4.8rem;
  }
`;
export const CustomInputTab = styled(InputTab)`
  .common-input {
    font-size: 2.4rem;
  }
  .input-container {
    min-height: 4.8rem;
  }
`;
